<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_manageapprove/_update/update.vue'
export default {
  components: {
    createContent
  }
}
</script>
